
	<prgov-alerts *ngIf="requirementItem.Comment" class="pr-5" [type]="'danger'">
        <div class="my-1">                
          <div class="row">
            <div class="col col-sm-12 col-md-12 col-lg-12">
				<div class="ml-2 d-flex align-items-center justify-content-stretch">
					<span class="h6 mt-2 mr-1">
					  <strong>
						{{ 'componentLoader.revisionComment' | translate }}
					  </strong>
					</span>
					<button *ngIf="!minimize"
							mat-stroked-button
							class="btn-display"
							(click)="minimizeRevisionAlert(true)"> 
						{{ 'componentLoader.view-less' | translate }}
						<mat-icon class="icon-display ml-auto">expand_less</mat-icon> 
					</button>  
					<button *ngIf="minimize"
							mat-stroked-button
							class="btn-display"
							(click)="minimizeRevisionAlert(false)">
						{{ 'componentLoader.view-more' | translate }}
						<mat-icon class="custom-icon-chevron ml-auto" >expand_more</mat-icon>
					</button>   
				  </div>  
            </div>
			<div *ngIf="minimize" class="col col-sm-12 col-md-12 col-lg-12">
                <div class="d-flex align-items-start ml-2">              
					<button class="d-flex align-items-stretch justify-content-center btn-display-submit"
							mat-stroked-button 
							color="primary"
							(click)="trySubmitForReview('submit-for-review')">
					<div>
						
					</div>
					<ng-container *ngIf="!isSaving()">
						{{ 'componentLoader.submitChangesForReview' | translate }}
					</ng-container>
					<ng-container 	*ngIf="isSaving() && saving.action=='submit-for-review'" 
									class="d-flex align-items-center spinner-wht justify-content-center">
						<mat-spinner [diameter]="20" class="mt-1 mat-spinner-color"></mat-spinner>
					</ng-container>
					<mat-icon *ngIf="!isSaving()" class="mb-1">send</mat-icon>
				</button>      
                </div>  
              </div>   
          </div> 
		  
		  <ng-container *ngIf="!minimize">
            <div class="row ml-2 mt-4">
              <div class="col col-sm-12 col-md-12 col-lg-12">
                <div class="h5 ml-3" [innerHtml]="requirementItem.Comment | keepHtml">              
                </div>
              </div>
            </div> 
            <div class="row ml-2 mt-2">
              <div class="col col-sm-12 col-md-12 col-lg-12">
                <div class="d-flex align-items-start ml-2">              
					<button class="d-flex align-items-stretch justify-content-center btn-display-submit"
							mat-stroked-button 
							color="primary"
							(click)="trySubmitForReview('submit-for-review')">
					<div>
						
					</div>
					<ng-container *ngIf="!isSaving()">
						{{ 'componentLoader.submitChangesForReview' | translate }}
					</ng-container>
					<ng-container 	*ngIf="isSaving() && saving.action=='submit-for-review'" 
									class="d-flex align-items-center spinner-wht justify-content-center">
						<mat-spinner [diameter]="20" class="mt-1 mat-spinner-color"></mat-spinner>
					</ng-container>
					<mat-icon *ngIf="!isSaving()" class="mb-1">send</mat-icon>
				</button>      
                </div>  
              </div>       
            </div>
          </ng-container> 
        </div>       
	</prgov-alerts>
	<div class="flex-row form-header-format custom-space-between m-3" >	
		<ng-container *ngIf="!requirementItem.Comment">
			<button class="d-n mt-2"  mat-raised-button 
				(click)="tryDownloadAsBlob('save-blob')"
				[disabled]="!isFormValid">
			<span *ngIf="!isSaving()">{{ 'save' | translate }}</span>  
			
			<div *ngIf="isSaving() && saving.action=='save-blob'"
			class="d-flex justify-content-center align-items-center">
				<mat-spinner  [diameter]="20" 
							class="mat-spinner-color">
				</mat-spinner>
			</div> 
		</button>
		</ng-container>		
		<div class="mt-2" [hidden]="serverError==''">
			<div class="server-error h4" >{{this.serverError}}</div>    				        			
		</div>	

		<button class="d-n mt-2 ml-1"
				mat-raised-button (click)="close()">
		  		{{ 'close' | translate }}   
		</button>	      		
	</div>	


<div class="row" >
	<div  class="col col-lg-12">
	  <div>
		<!-- {{ mainService.formData | json }} -->
		<ngx-extended-pdf-viewer [src]="pdfSrc" [height]="'90vh'" [formData]="mainService.formData" (formDataChange)="onFormChange($event)"> 
		</ngx-extended-pdf-viewer>
	  </div>
	</div> 
</div> 

